export const DocumentViewer = {
  display: (el, s) => s.root.selectedDocument ? 'flex' : 'none',
  flow: 'y',
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,.85)',
  zIndex: '1000',

  ViewerToolbar: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    padding: 'Z A',
    background: 'ink',
    borderBottom: '1px solid inkBorder',
    flexShrink: '0',

    LeftInfo: {
      flow: 'x',
      align: 'center flex-start',
      gap: 'Z',
      DocName: {
        text: (el, s) => s.root.selectedDocument?.filename || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText'
      },
      DocType: {
        tag: 'span',
        text: (el, s) => {
          const t = s.root.selectedDocument?.type || ''
          if (t === 'xray') return 'X-ray'
          if (t === 'ctScan') return 'CT Scan'
          if (t === 'intraoral3d') return '3D Scan'
          if (t === 'photo') return 'Photo'
          return t
        },
        fontSize: 'Y',
        padding: 'X Y',
        round: 'B',
        background: 'inkSurface',
        color: 'inkMuted'
      }
    },

    CenterControls: {
      flow: 'x',
      align: 'center center',
      gap: 'Y',

      ZoomOutBtn: {
        extends: 'Button',
        text: '\u2212',
        fontSize: 'A',
        width: 'B',
        height: 'B',
        round: 'Y',
        background: 'inkSurface',
        color: 'inkText',
        cursor: 'pointer',
        border: '1px solid inkBorder',
        align: 'center center',
        display: 'flex'
      },
      ZoomLabel: { text: '100%', fontSize: 'Y', color: 'inkMuted', minWidth: 'B1', textAlign: 'center' },
      ZoomInBtn: {
        extends: 'Button',
        text: '+',
        fontSize: 'A',
        width: 'B',
        height: 'B',
        round: 'Y',
        background: 'inkSurface',
        color: 'inkText',
        cursor: 'pointer',
        border: '1px solid inkBorder',
        align: 'center center',
        display: 'flex'
      },

      Divider: { width: '1px', height: 'A', background: 'inkBorder' },

      BrightnessGroup: {
        flow: 'x',
        align: 'center center',
        gap: 'X',
        BrLabel: { text: '{{ brightness | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
        BrSlider: { tag: 'input', attr: { type: 'range', min: '0', max: '200', value: '100' }, width: 'C1', accentColor: 'teal' }
      },

      ContrastGroup: {
        flow: 'x',
        align: 'center center',
        gap: 'X',
        CoLabel: { text: '{{ contrast | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
        CoSlider: { tag: 'input', attr: { type: 'range', min: '0', max: '200', value: '100' }, width: 'C1', accentColor: 'teal' }
      },

      Divider2: { width: '1px', height: 'A', background: 'inkBorder' },

      AnnotateBtn: {
        extends: 'Button',
        text: '{{ annotate | polyglot }}',
        fontSize: 'Y',
        padding: 'X Z',
        round: 'Y',
        background: 'inkSurface',
        color: 'inkText',
        cursor: 'pointer',
        border: '1px solid inkBorder'
      },
      CompareBtn: {
        extends: 'Button',
        text: '{{ beforeAfter | polyglot }}',
        fontSize: 'Y',
        padding: 'X Z',
        round: 'Y',
        background: 'inkSurface',
        color: 'inkText',
        cursor: 'pointer',
        border: '1px solid inkBorder'
      }
    },

    CloseBtn: {
      extends: 'Button',
      text: '\u2715',
      fontSize: 'A',
      width: 'B',
      height: 'B',
      round: 'Y',
      background: 'inkSurface',
      color: 'inkText',
      cursor: 'pointer',
      border: '1px solid inkBorder',
      align: 'center center',
      display: 'flex',
      on: {
        click: (e, el, s) => s.root.update({ selectedDocument: null })
      }
    }
  },

  ViewerCanvas: {
    flex: '1',
    display: 'flex',
    align: 'center center',
    overflow: 'auto',

    PlaceholderArea: {
      width: 'H',
      height: 'G',
      maxWidth: '90%',
      maxHeight: '80vh',
      round: 'A',
      background: 'inkMid',
      border: '2px dashed inkBorder',
      display: 'flex',
      align: 'center center',
      flow: 'y',
      gap: 'Z',
      PlaceholderIcon: {
        extends: 'Icon',
        name: (el, s) => {
          const t = s.root.selectedDocument?.type || 'other'
          if (t === 'xray') return 'scan'
          if (t === 'ctScan') return 'layers'
          if (t === 'intraoral3d') return 'box'
          if (t === 'photo') return 'camera'
          return 'file'
        },
        fontSize: 'E',
        color: 'inkMuted'
      },
      PlaceholderText: {
        text: (el, s) => s.root.selectedDocument?.filename || '{{ documentPreview | polyglot }}',
        fontSize: 'A',
        color: 'inkMuted',
        textAlign: 'center'
      },
      PlaceholderMeta: {
        text: (el, s) => {
          const d = s.root.selectedDocument
          if (!d) return ''
          const parts = []
          if (d.device) parts.push(d.device)
          if (d.tooth) parts.push(`Tooth #${d.tooth}`)
          if (d.date) parts.push(d.date)
          return parts.join('  \u00b7  ')
        },
        fontSize: 'Z',
        color: 'inkMuted'
      }
    }
  }
}
